import Box from "@jewlr/storybook/core/box"
import Button from "@jewlr/storybook/core/button"
import Typography from "@jewlr/storybook/core/typography"
import Select from "@jewlr/storybook/form/select"
import styled from "styled-components"

export const ItemTitle = styled(Typography).attrs((props) => ({
  color: "black",
  fontSize: 16,
  fontWeight: "700",
  lineHeight: "22px",
  mb: { _: "5px", tablet: props.complete ? 1 : 0 },
  mx: "auto",
  width: props.complete && { tablet: "80%" },
  ...props,
}))``
export const ItemDetails = styled(Typography).attrs((props) => ({
  color: "black",
  fontSize: "16px",
  fontWeight: "300",
  lineHeight: "22px",
  margin: "auto",
  pb: {
    _: props.complete ? 5 : "10px",
  },
  width: props.complete && { tablet: "80%" },
  ...props,
}))`
  word-break: break-word;
`

export const Heading = styled(Typography).attrs((props) => ({
  as: "h2",
  fontSize: "26px",
  fontWeight: "500",
  lineHeight: "30px",
  mb: 4,
  ...props,
}))``

export const Title = styled(Typography).attrs((props) => ({
  fontSize: "20px",
  mb: 4,
  ...props,
}))``

export const Btn = styled(Button).attrs((props) => ({
  bg: props.complete ? props.theme.colors.primary : props.theme.payment.btn.bg,
  color: "white",
  fontSize: "14px",
  p: "12px 20px",
  sz: "sm",
  ...props,
}))``
export const Text = styled(Box).attrs((props) => ({
  mb: props.error ? (props.show ? "10px" : "0") : "10px",
  ...props,
}))`
  color: ${(props) => (props.show ? "red" : "black")};
  display: ${(props) =>
    props.error ? (props.show ? "block" : "none") : "block"};
  font-size: 16px;

  ${(props) => props.theme.mediaQueries.tablet`
    display: ${(props) => (props.error ? "none" : "block")};
  `}
`

export const FieldError = styled.p`
  color: ${(props) => props.theme.colors.error};
  font-size: 12px;
  margin-top: 8px;
  text-align: left;
`

export const Tooltip = styled.div`
  display: ${(props) => (props.error ? "none" : "block")};
  margin-left: 5px;
  position: relative;
  vertical-align: middle;
  ${(props) => props.theme.mediaQueries.tablet`
    display: block;
  `}
`

export const TooltipText = styled(Typography).attrs({
  as: "span",
  left: { tablet: "160%" },
  right: { _: "20px", tablet: "auto" },
})`
  background-color: ${(props) => props.theme.colors.black};
  border-radius: 4px;
  color: ${(props) => props.theme.colors.white};
  display: none;
  font-size: 14px;
  line-height: 1.4em;
  padding: 10px;
  position: absolute;
  text-align: left;
  top: ${(props) => (props.top ? props.top : "-35px")};
  width: ${(props) => (props.width ? props.width : "200px")};
  z-index: 999;

  ${Tooltip}:hover & {
    display: inline-block;
  }

  &::after {
    ${(props) => props.theme.mediaQueries.tablet`
           border-color: transparent ${
             props.theme.colors.black
           } transparent transparent;
           border-style: solid;
           border-width: 5px;
           content: " ";
           margin-top: -28px;
           position: absolute;
           right: 100%;
           top: ${(props) => (props.arrowTop ? props.arrowTop : "24px")};
           `}
  }

  // arrow on the right of the tooltip
  &::before {
    ${(props) => props.theme.mediaQueries.tablet`
          display:none;
      `}
    border-color: transparent transparent transparent ${(props) =>
      props.theme.colors.black};
    border-style: solid;
    border-width: 5px;
    content: " ";
    margin-top: -3px;
    position: absolute;
    left: 100%;
    top: ${(props) => (props.arrowTop ? props.arrowTop : "24px")};
  }
`

export const PaymentSelect = styled(Select).attrs({
  color: "grey.65",
})``
export const PaymentContainer = styled(Box).attrs((props) => ({
  alignItems: "center",
  borderBottom: {
    _: `solid 1px ${props.theme.colors.grey[20]}`,
    tablet: "none",
  },
  flex: { desktop: "24%", tablet: "50%" },
  height: { desktop: "94px" },
  mb: { _: 2, tablet: 0 },
  mx: { _: 2, tablet: 0 },
  px: { _: 4, tablet: 0 },
  py: { _: 0, tablet: 2 },
  ...props,
}))`
  ${(props) =>
    `
     &:last-child {
          border-bottom: none;
        }
      ${props.theme.mediaQueries.tablet`
        :nth-child(odd) {
          border-right: solid 1px ${props.theme.colors.grey[20]};
        }
      `}
      ${props.theme.mediaQueries.desktop`
        border-right:  solid 1px ${props.theme.colors.grey[20]};
        &:last-child {
          border-right: none;
        }
      `}
    `};
`

export const FooterWrapper = styled(Box).attrs({
  borderTop: "1px solid black",
  mt: 6,
  p: "25px 0",
  textAlign: "center",
})``
//Title Bar

export const HelpBar = styled(Box)`
  background-color: #313131;
  text-align: center;
  ${({ theme }) => theme.mediaQueries.tablet`
       text-align: left;
  `};
`
export const PaymentWrapper = styled(Box)`
  margin-left: auto;
  margin-right: auto;
  max-width: 735px;
  text-align: center;

  ${({ theme }) => theme.mediaQueries.tablet`
   max-width: 1005px;
   justify-content: space-between;
  `};

  ${({ theme }) => theme.mediaQueries.desktop`
   max-width: 1020px;
   justify-content: space-between;
  `};
`
export const HelpBarContainer = styled(Box)`
  align-items: center;
  color: #fff;
  display: flex;
  height: 35px;
  margin-left: auto;
  margin-right: auto;
  max-width: 735px;

  ${({ theme }) => theme.mediaQueries.tablet`
   max-width: 1005px;
   justify-content: space-between;
  `};

  ${({ theme }) => theme.mediaQueries.desktop`
   max-width: 1020px;
   justify-content: space-between;
  `};
`
export const HelpBarListCenter = styled(Box).attrs({
  as: "ul",
})`
  list-style: none;
  margin: auto;
  padding: 0;
  text-align: center !important;
  ${({ theme }) => theme.mediaQueries.desktop`
       margin: 0;
  `};
`

export const HelpBarList = styled.ul`
  display: none;
  list-style: none;
  margin: 0;
  padding: 0;
  ${({ theme }) => theme.mediaQueries.tablet`
       display: flex;
  `};
`

export const HelpBarListItem = styled(Box).attrs({
  as: "li",
})`
  padding: 0 5px;
  &:after {
    color: #fff;
    content: "|";
    font-weight: 700;
    left: 5px;
    position: relative;
    top: 0;

    ${({ theme }) => theme.mediaQueries.desktop`
       left: 6px;
  `};
  }
  &:last-child {
    padding-right: 0;
    &::after {
      content: none;
    }
  }

  &:first-child {
    padding-left: 0;
  }
`
export const HelpBarLinks = styled(Box).attrs((props) => ({
  as: "a",
  ...props,
}))`
  display: inline-block;
  font-size: 14px;
  padding: 0 3px;
  text-transform: uppercase;
  ${({ theme }) => theme.mediaQueries.tablet`
    font-size: 10px;

`};

  ${({ theme }) => theme.mediaQueries.desktop`
    padding: 0 5px;
    font-size: 12px;

`};
`

export const TitleBarWrap = styled(Box).attrs((props) => ({
  alignItems: "center",
  display: { _: "flex", tablet: "block" },
  mb: { tablet: 3 },
  pt: { _: 1, tablet: 20 },
  ...props,
}))`
  margin-left: auto;
  margin-right: auto;
  max-width: 735px;

  ${({ theme }) => theme.mediaQueries.tablet`
   max-width: 1005px;
   justify-content: space-between;
  `};

  ${({ theme }) => theme.mediaQueries.desktop`
   max-width: 1020px;
   justify-content: space-between;
  `};
`
export const SubmitButton = styled(Button).attrs({
  type: "submit",
  variant: "primary",
})`
  font-size: 18px;
  font-weight: 500;
  line-height: 16px;
  padding: 14px 50px;
  width: 100%;
`
export const FormWrapper = styled(Box).attrs({
  maxWidth: { tablet: "656px" },
})``
export const ColWrapper = styled(Box).attrs({
  maxWidth: { tablet: "320px" },
})``
export const InfoWrap = styled(Box)`
  background: #f5f5f5;
  border-radius: 10px;
  padding: 16px 12px;
`
export const InfoText = styled(Typography)`
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -0.02em;
  line-height: 22px;

  strong {
    font-weight: 500;
  }
`
export const InputLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 6px;
`

export const PaypalButton = styled(Button)`
  background: #ffcc00;
  color: black;
  font-size: 18px;
  font-weight: 500;
  line-height: 16px;
  padding: 10.5px 50px;
  width: 100%;
`
